import BaseApi from './baseApi';
import ISellsDetail from '../models/ISellsDetail';
import IAuthentication from '../models/IAuthentication';
export default class SellsDetailApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Sells");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetSellsDetail(sellId: string) : Promise<ISellsDetail[]> {
        let json : string = this.getJsonRead(sellId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var sells: ISellsDetail[] = [];
            sells = response.data as ISellsDetail[];
            for (let i = 0; i < sells.length; i++) {
                const sell = sells[i];
                sell.totalCases = sell.palletsAmount * sell.casesAmountPallet;
            }
            return sells;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveSellDetail(sellDetail: ISellsDetail) : Promise<string> {
        const json = this.getJsonSave(sellDetail);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateSellDetail(sellDetail: ISellsDetail) : Promise<boolean> {
        const json = this.getJsonUpdate(sellDetail);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteSellDetail(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDetailBySellId(sellId: string) : Promise<boolean> {
        const json = this.getJsonDeleteBySellId(sellId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteBySellId(sellId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "SellsDetail",
            "conditions": [{
                "Item1": "SellsDetail",
                "Item2": "idSell",
                "Item3": "=",
                "Item4": sellId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "conditions": [{
                "Item1": "sellsDetail",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }],
            "table": "sellsDetail"
        };
        return json;
    }

    private getJsonSave(sellDetail: ISellsDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idSell",
                "Item2": sellDetail.idSell
            }, {
                "Item1": "idInbound",
                "Item2": sellDetail.idInbound
            }, {
                "Item1": "idGood",
                "Item2": sellDetail.idGood
            }, {
                "Item1": "idListPallet",
                "Item2": sellDetail.idListPallet
            }, {
                "Item1": "palletsAmount",
                "Item2": sellDetail.palletsAmount
            }, {
                "Item1": "casesAmountPallet",
                "Item2": sellDetail.casesAmountPallet
            }, {
                "Item1": "goodsPerCase",
                "Item2": sellDetail.goodsPerCase
            }, {
                "Item1": "idInboundDeliveryNoteDetail",
                "Item2": sellDetail.idInboundDeliveryNoteDetail
            }, {
                "Item1": "bestBeforeDate",
                "Item2": sellDetail.bestBeforeDate
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "SellsDetail"
        };
        return json;
    }

    private getJsonUpdate(sellDetail: ISellsDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idSell",
                "Item2": sellDetail.idSell
            }, {
                "Item1": "idInbound",
                "Item2": sellDetail.idInbound
            }, {
                "Item1": "idGood",
                "Item2": sellDetail.idGood
            }, {
                "Item1": "idListPallet",
                "Item2": sellDetail.idListPallet
            }, {
                "Item1": "palletsAmount",
                "Item2": sellDetail.palletsAmount
            }, {
                "Item1": "casesAmountPallet",
                "Item2": sellDetail.casesAmountPallet
            }, {
                "Item1": "goodsPerCase",
                "Item2": sellDetail.goodsPerCase
            }, {
                "Item1": "idInboundDeliveryNoteDetail",
                "Item2": sellDetail.idInboundDeliveryNoteDetail
            }, {
                "Item1": "bestBeforeDate",
                "Item2": sellDetail.bestBeforeDate
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "SellsDetail",
            "keyvalue": sellDetail.id
        };
        return json;
    }

    private getJsonRead(sellId: string) : any {
        const json = {
            "fields": [{
                "Item1": "SellsDetail",
                "Item2": "id"
            }, {
                "Item1": "SellsDetail",
                "Item2": "idSell"
            }, {
                "Item1": "SellsDetail",
                "Item2": "idInbound"
            }, {
                "Item1": "Inbounds",
                "Item2": "code as inboundCode"
            }, {
                "Item1": "SellsDetail",
                "Item2": "idGood"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "SellsDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as palletName"
            }, {
                "Item1": "SellsDetail",
                "Item2": "palletsAmount"
            }, {
                "Item1": "SellsDetail",
                "Item2": "casesAmountPallet"
            }, {
                "Item1": "SellsDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SellsDetail",
                "Item2": "idInboundDeliveryNoteDetail"
            }, {
                "Item1": "SellsDetail",
                "Item2": "bestBeforeDate"
            }],
            "tables": [{
                "Item1": "SellsDetail"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "Inbounds"
            }],
            "conditions": [{
                "Item1": "SellsDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "SellsDetail",
                "Item2": "idSell",
                "Item3": "=",
                "Item4": sellId
            }],
            "joins": [{
                "Item1": "SellsDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "SellsDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "SellsDetail",
                "Item2": "idInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }]
        };
        return json;
    }
}
